import { useTranslation } from 'react-i18next'
import './_successfulChange.scss'

interface SuccessfulChangeProps {
    img: string | JSX.Element | JSX.Element[]
    text: string | JSX.Element | JSX.Element[]
    header?: string
}

export const SuccessfulChange = ({
    img,
    text,
    header
}: SuccessfulChangeProps) => {
    const { t } = useTranslation()
    return (
        <div className='successfullChange'>
            {typeof img === 'string' ? (
                <img src={img} alt='Success logo' />
            ) : (
                img
            )}
            <h2>{header ?? t('Success!')}</h2>
            <p>{text}</p>
        </div>
    )
}
